









































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import GoodSelect from '@/components/goods-select/index.vue'
import PicModal from '@/components/upload/picModal.vue'
import GoodsApi from '@/api/goods/list'
@Component({
  components: {
    GoodSelect,
    PicModal,
  },
})
export default class Products extends Vue {
  @Prop({
    type: Boolean,
    default: () => false,
  })
  showDemo!: boolean

  @Prop({
    type: Object,
    default: () => {
      return {
        type: 'products',
        maxNumber: 4,
        name: '商品列表',
        displayOrder: '',
        isActive: true,
        backgroundType: 0,
        backgroundUrl: null,
        isDisplayName: false,
        // 0多图组件/1商品列表/2营销活动
        componentType: 1,
        // 图片组件数据
        photosComponent: {
          // 0表示图片 1表示轮播
          displayType: 0,
          displayMode: null,
          photoItems: [],
        },
        // 商品组件数据
        productsComponent: {
          productItems: [],
        },
        // 活动组件
        activitiesComponent: {
          activityItems: [],
        },
      }
    },
  })
  ProductsConfig!: any

  showGoodsIndex = -1

  get showImg() {
    return require('@/assets/images/goodStyle-3.jpg')
  }

  /**
   * 将商品数组拆成每 rowNmuber 个一组
   */
  get goodList() {
    let result = []
    for (var i = 0; i < this.ProductsConfig.productsComponent.productItems.length; i += 4) {
      result.push(this.ProductsConfig.productsComponent.productItems.slice(i, i + 4))
    }
    console.log('啦啦啦', result);
    return result
  }

  @Watch('ProductsConfig.maxNumber')
  changeProductCount(newVal, oldVal){
    if(newVal < oldVal){
      this.ProductsConfig.productsComponent.productItems.splice(newVal,oldVal - newVal)
    }
  }

  mounted() {
  }


  /**
   * 选择商品信息
   */
  productsChange(e) {
    if (e) {
      e.forEach((item, index) => {
        if (
          this.ProductsConfig.productsComponent.productItems.findIndex(item1 => item1.id == item.id) < 0 &&
          index < this.ProductsConfig.maxNumber &&
          this.ProductsConfig.productsComponent.productItems.length < this.ProductsConfig.maxNumber
        ) {
          this.ProductsConfig.productsComponent.productItems.push(item)
        }
      })
    }
  }

  /**
   * 鼠标移入/移出事件
   */
  onMouseFn(index?) {
    this.showGoodsIndex = index
  }

  /**
   * 删除所选商品
   */
  deleteFn(index) {
    this.ProductsConfig.productsComponent.productItems.splice(index, 1)
  }
}
